import { Reveal, Eyebrow } from "./Reveal";
import { useApp } from "../store";

const toYoutubeEmbed = (url) => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};

export const VideoSection = () => {
  const { c, t } = useApp();
  const url = (c("video_url") || "").trim();
  if (!url) return null;
  const embed = toYoutubeEmbed(url);

  return (
    <section id="video" data-testid="video-section" className="relative text-white grain" style={{ background: "var(--sec-video-bg, #101E3D)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="max-w-2xl mb-12">
          <Eyebrow>{t("video_eyebrow")}</Eyebrow>
          <h2 data-testid="video-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            {c("video_title")}
          </h2>
          <p data-testid="video-text" className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">
            {c("video_text")}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -top-3 -left-3 w-24 h-24 border-t-2 border-l-2 border-[var(--accent)] pointer-events-none" />
            <div className="absolute -bottom-3 -right-3 w-24 h-24 border-b-2 border-r-2 border-[var(--accent)] pointer-events-none" />
            <div data-testid="video-player" className="relative aspect-video bg-white/[0.05] border border-[var(--accent-soft)]/10 overflow-hidden">
              {embed ? (
                <iframe
                  src={embed}
                  title={c("video_title")}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <video src={url} controls playsInline className="w-full h-full object-contain" />
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
